import { getSession, setSession } from "./useBrowserStorage";

const useThemeSwitcher = (value) => {
    const getStorage = getSession("theme");

    let themeResult;

    // initial render - both value and storage not available
    if (value === null && getStorage === null) {
        if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
            themeResult = "dark";
        }

        if (window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches) {
            themeResult = "light";
        }
    }

    // value is available but storage is not available
    if (value !== null && getStorage === null) {
        setSession("theme", value);
        themeResult = value;
    }

    // value is not available but storage is available
    if (value === null && getStorage !== null) {
        themeResult = getStorage;
    }

    // both value and storage is available
    if (value !== null && getStorage !== null) {
        if (getStorage !== value) {
            setSession("theme", value);
        }

        themeResult = value;
    }

    if (themeResult === "dark") {
        return darkModeStyles({ mode: "dark" });
    } else if (themeResult === "light") {
        return lightModeStyles({ mode: "light" });
    } else if (themeResult === "system") {
        return systemModeStyles();
    }
};

const darkModeStyles = (modes) => {
    return {
        ...modes,
        styles: {
            theme: "dark",
            background: "var(--clr-black--primary)",
            cardColor: "var(--clr-black--secondary)",
            textColor: "var(--clr-white--primary)",
            subCardColor: "var(--clr-black--tertiary)",
            subTextColor: "#979797",
            accentColor: "var(--clr--primary)",
        },
    };
};

const lightModeStyles = (modes) => {
    return {
        ...modes,
        styles: {
            theme: "light",
            background: "var(--clr-white--primary)",
            cardColor: "white",
            textColor: "var(--clr-black--primary)",
            accentColor: "var(--clr--secondary)",
        },
    };
};

const systemModeStyles = () => {
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        return darkModeStyles({ mode: "system" });
    }

    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches) {
        return lightModeStyles({ mode: "system" });
    }
};

export default useThemeSwitcher;
